import CircleIcon from '@mui/icons-material/Circle';
import Tab from '@mui/material/Tab';
import React from 'react';


//given a state variable that says weather notification should show or not
//will return a regular tab that shows either nothing if state = false
//or shows a dot to the right end of the tab if state = true
export default function NotificationTab({ state, ...props }) {

  function dot(bool) {
    if (bool === true) {
      return (
        <CircleIcon fontSize='x-small' sx={{color: "red"}}/>
      )
    }
    else return (
      <></>
    )
  } 

  return (
    <Tab icon={dot(state)} iconPosition="end" {...props}/>
  )
}